<template>
    <!-- ブラウザ -->
    <fieldset id="testEnv">
        <legend>テスト環境(任意)</legend>
        <div>
            テスト実行時に使用するブラウザやサービスを選択してください。<br>
            何も選択しなかった場合、テストランのテスト環境に設定されている環境を使用します。
            <TestEnvHelp />
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. AnyTestを使用する場合、テストラン作成時にテスト環境でAnyTestを設定してください。
        </div>
        <div class="form-area">
            <input type="checkbox" id="browserChrome" v-model="selectedBrowser.Chrome" class="input-checkbox"
                @change="changeBrowserState('Chrome')">
            <label for="browserChrome">Chrome</label><br>
            <input type="checkbox" id="browserEdge" v-model="selectedBrowser.Edge" class="input-checkbox"
                @change="changeBrowserState('Edge')">
            <label for="browserEdge">Edge</label><br>
            <input type="checkbox" id="browserFireFox" v-model="selectedBrowser.FireFox" class="input-checkbox"
                @change="changeBrowserState('FireFox')">
            <label for="browserFireFox">FireFox</label><br>
            <input type="checkbox" id="browserAnyTest" v-model="selectedBrowser.AnyTest" class="input-checkbox"
                @change="changeBrowserState('AnyTest')">
            <label for="browserAnyTest">AnyTest (テストランのテスト環境に設定されている環境を使用します。)</label>
        </div>
    </fieldset>

    <!-- ブラウザバックグラウンド実行 -->
    <fieldset id="background">
        <legend>ブラウザ表示</legend>
        <div>テスト実行時に、ブラウザを表示するかを選択してください。</div>
        <div class="form-area">
            <input type="radio" class="input-radio" id="backgroundRadio" v-model="selectedBackground"
                name="backgroundRadio" :value="true" @change="updateOpt" checked>
            <label for="backgroundRadio">バックグラウンド実行する</label><br>
            <input type="radio" class="input-radio" id="notBackgroundRadio" v-model="selectedBackground"
                name="backgroundRadio" :value="false" @change="updateOpt">
            <label for="notBackgroundRadio">バックグラウンド実行しない</label><br>
        </div>
    </fieldset>
</template>

<script>
import { onMounted, reactive, ref } from 'vue';
import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'BrowserForm',
    props: ["showUseExistingTestOpt"],
    setup(_, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const selectedBrowser = reactive({
            "Chrome": false,
            "Edge": false,
            "FireFox": false,
            "AnyTest": false,
        });
        const selectedBackground = ref(true)


        // ################
        // ブラウザ選択制御 #
        // ################
        const changeBrowserState = async (clickTarget) => {
            const isUseAnyTest = clickTarget === "AnyTest"
            // AnyTestがクリックされ有効化した時、他のブラウザは無効化
            if (selectedBrowser.AnyTest && isUseAnyTest) {
                selectedBrowser.Chrome = false
                selectedBrowser.Edge = false
                selectedBrowser.FireFox = false
            }
            // 他のブラウザがクリックされ有効化した時、AnyTestは無効化
            const isUseNormalBrowser = selectedBrowser.Chrome || selectedBrowser.Edge || selectedBrowser.FireFox
            if (isUseNormalBrowser && !isUseAnyTest) {
                selectedBrowser.AnyTest = false
            }
            // コマンドを更新
            await updateOpt()
        }

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            let createdOpt = ""

            // ブラウザ
            let browserOpt = ""
            if (!selectedBrowser.AnyTest) {
                for (const key in selectedBrowser) {
                    if (!selectedBrowser[key]) {
                        continue
                    }
                    if (browserOpt) {
                        browserOpt += "/"
                    } else {
                        browserOpt += " --browser "
                    }
                    browserOpt += `${key}`
                }
            }
            createdOpt += browserOpt

            // バックグラウンド実行
            if (selectedBackground.value) {
                createdOpt += " --background"
            }

            // cacheに保存
            await cacheUtils.saveData("browserChrome", selectedBrowser.Chrome)
            await cacheUtils.saveData("browserEdge", selectedBrowser.Edge)
            await cacheUtils.saveData("browserFireFox", selectedBrowser.FireFox)
            await cacheUtils.saveData("browserAnyTest", selectedBrowser.AnyTest)
            await cacheUtils.saveData("browserBackground", selectedBackground.value)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "browser", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            selectedBrowser.Chrome = await cacheUtils.getData("browserChrome", false)
            selectedBrowser.Edge = await cacheUtils.getData("browserEdge", false)
            selectedBrowser.FireFox = await cacheUtils.getData("browserFireFox", false)
            selectedBrowser.AnyTest = await cacheUtils.getData("browserAnyTest", false)
            selectedBackground.value = await cacheUtils.getData("browserBackground", true)

            await updateOpt()
        })

        return {
            // フォームデータ
            selectedBrowser,
            selectedBackground,
            // フォーム制御
            changeBrowserState,
            // コマンド生成
            updateOpt,
        }
    }
}
</script>
